import { forwardRef, useImperativeHandle, useState } from "react";
import Select2 from "./select2/Select2";
import { set } from "react-hook-form";
import ErrorToast from "./toasts/ErrorToast";

const DataLoggerProperties = forwardRef((props, ref) => {
  const [dataAddress, setDataAddress] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [slaveAddress, setSlaveAddress] = useState(null);
  const [functionCode, setFunctionCode] = useState(null);
  const [dividedBy, setDividedBy] = useState(null);
  const [multipliedBy, setMultipliedBy] = useState(null);
  const [isSigned, setIsSigned] = useState(false);

  useImperativeHandle(ref, () => ({
    // getData: () => {
    //   let digit = slaveAddress;
    //   let data1 = functionCode;
    //   let data2 = splitIntoTwoBytes(dataAddress)[0];
    //   let data3 = splitIntoTwoBytes(dataAddress)[1];
    //   let data4 = quantity;
    //   let data5;
    //   if (
    //     functionCode == 1 ||
    //     functionCode == 2 ||
    //     functionCode == 3 ||
    //     functionCode == 4
    //   ) {
    //     data5 = dividedBy.toString(2).padStart(8, "0");
    //     isSigned ? (data5[7] = 1) : (data5[7] = 0);
    //   } else if (functionCode == 6) {
    //     data5 = multipliedBy.toString(2).padStart(8, "0");
    //   } else if (functionCode == 5) {
    //     data5 = null;
    //   }
    //   return [digit, data1, data2, data3, data4, data4];
    // },

    getData: () => {
      return {
        slaveAddress,
        functionCode,
        dataAddress,
        quantity,
        dividedBy,
        multipliedBy,
        isSigned,
      };
    },
  }));

  const handleNumericValue = (value, min, max, setValue) => {
    const numericValue = Number(value);

    if (!Number.isInteger(numericValue)) {
      return setValue("");
    }
    if (numericValue <= min) {
      return setValue(min);
    } else if (numericValue >= max) {
      return setValue(max);
    }

    setValue(numericValue);
  };

  return (
    <div className="row mx-auto" style={{ maxWidth: "450px", height: "100%" }}>
      <div className="col-12 mt-4">
        <div>
          <label for="select2Basic" className="form-label">
            آدرس اسلیو
          </label>
          <Select2
            parentElem={"#selectDevice"}
            options={Array.from({ length: 250 }, (_, i) => ({
              name: i + 1,
              value: i + 1,
            }))}
            value={slaveAddress}
            setValue={setSlaveAddress}
          />
        </div>
        <div>
          <label for="select2Basic" className="form-label">
            کد تابع
          </label>
          <Select2
            parentElem={"#selectDevice"}
            options={Array.from({ length: 6 }, (_, i) => ({
              name: i + 1,
              value: i + 1,
            }))}
            value={functionCode}
            setValue={setFunctionCode}
          />
        </div>
        <div>
          <label for="defaultFormControlInput" className="form-label">
            آدرس داده (65535-0)
          </label>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              handleNumericValue(e.target.value, 0, 65535, setDataAddress)
            }
            value={dataAddress}
          />
        </div>
        {functionCode == 1 ||
        functionCode == 2 ||
        functionCode == 3 ||
        functionCode == 4 ? (
          <div>
            <div>
              <label for="select2Basic" className="form-label">
                تعداد
              </label>
              <Select2
                parentElem={"#selectDevice"}
                options={Array.from({ length: 16 }, (_, i) => ({
                  name: i + 1,
                  value: i + 1,
                }))}
                value={quantity}
                setValue={setQuantity}
              />
            </div>
            {/* <div>
              <label for="defaultFormControlInput" className="form-label">
                تقسیم بر (1-100)
              </label>
              <input
                type="text"
                className="form-control"
                value={dividedBy}
                onChange={(e) =>
                  handleNumericValue(e.target.value, 1, 100, setDividedBy)
                }
              />
            </div> */}
          </div>
        ) : null}
        {functionCode == 6 ? (
          <div>
            <label for="defaultFormControlInput" className="form-label">
              ضرب در (1-100)
            </label>
            <input
              type="text"
              className="form-control"
              value={multipliedBy}
              onChange={(e) =>
                handleNumericValue(e.target.value, 1, 100, setMultipliedBy)
              }
            />
          </div>
        ) : null}

        {/* {functionCode == 1 ||
        functionCode == 2 ||
        functionCode == 3 ||
        functionCode == 4 ? (
          <div className="form-check mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              value={isSigned}
              onChange={(e) => setIsSigned(e.target.checked)}
              id="defaultCheck1"
            />
            <label className="form-check-label" for="defaultCheck1">
              علامت دار
            </label>
          </div>
        ) : null} */}
      </div>
    </div>
  );
});

export default DataLoggerProperties;
